/**
 * Рамка кадра карты Astra (agroai-6al.64).
 *
 * Порядок: ручной перевод камеры («показать наблюдение») → контуры фокуса,
 * чья геометрия уже загружена → рамка страницы → район. Контуры без
 * геометрии в рамку не входят; если ни у одного геометрии нет — остаётся
 * район (или рамка страницы), а когда фичи придут, рамка пересчитывается.
 * Зум одного-двух контуров ограничивает полотно (потолок зума фокуса).
 */

import { geoBounds, type Bbox } from '../../features/map/mapModel';

type GeoLike = Parameters<typeof geoBounds>[0][number];

/** Доля рамки, добавляемая с каждой стороны: крайние контуры не прижаты к краю кадра. */
const FOCUS_MARGIN = 0.06;

export function padBbox(box: Bbox, ratio = FOCUS_MARGIN): Bbox {
  const dx = (box[2] - box[0]) * ratio;
  const dy = (box[3] - box[1]) * ratio;
  return [box[0] - dx, box[1] - dy, box[2] + dx, box[3] + dy];
}

export function resolveFitBbox(args: {
  watchFit: Bbox | null;
  focusIds: ReadonlyArray<string>;
  featuresById: ReadonlyMap<string, ReadonlyArray<unknown>>;
  pageBbox: Bbox | null;
  districtBbox: Bbox;
}): Bbox {
  if (args.watchFit) return args.watchFit;
  if (args.focusIds.length > 0) {
    const chosen = args.focusIds.flatMap((id) => args.featuresById.get(id) ?? []);
    const box = geoBounds(chosen as unknown as GeoLike[]);
    if (box) return padBbox(box);
  }
  return args.pageBbox ?? args.districtBbox;
}
